module.exports = __webpack_public_path__ + "img/wein-kultur.905aad76.jpg";